import React from 'react';
import Utilities from '@util/Utilities';

const RateChange: React.FunctionComponent<{
	rate: number,
	variant?: 'pill' | 'text'
}> = ({ rate, variant = 'pill' }) => {
	const formatted = Utilities.formatDouble(rate * 100, 0);
	const value = rate > 0 ? `+${formatted}%` : `${formatted}%`;
	const isNonNegative = rate >= 0;

	if (variant === 'text') {
		return isNonNegative
			? <span className="font-bold text-green-600">{value}</span>
			: <span className="font-bold text-red-600">{value}</span>;
	}

	return isNonNegative
		? <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-semibold text-green-700 ring-1 ring-inset ring-green-600/10">{value}</span>
		: <span className="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-semibold text-red-700 ring-1 ring-inset ring-red-600/10">{value}</span>;
};

export default RateChange;
